import React from "react";
import { Formik, Field } from "formik";
import { View, Text } from "react-native";
import TextInput from "../../forms/textInput";
import CounterInput from "../../forms/counterInput";
import Button from "../../forms/button";
import styled from "styled-components/native";

import { Theme, attributes } from "../../theme";

const CenteredContainer = styled.View`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
  min-height: 550px;
`;

const OptionsContainer = styled.View`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const OptionContainer = styled.View`
  display: flex;
  align-items: center;
  width: 300px;
  margin-top: 30px;
`;

const OptionText = styled.Text`
  font-size: 16px;
`;

const OptionDescription = styled.Text`
  color: ${attributes.descriptionColor};
  margin-top: 5px;
`;

const OptionInputContainer = styled.View`
  align-items: center;
  margin-top: 10px;
`;

const ButtonContainer = styled.View`
  display: flex;
  margin: 40px 0;
`;

const NameContainer = styled.View`
  text-align: center;
  width: 250px;
  margin-top: 20px;
`;

const FieldName = styled.View``;

interface CreateGameProps {}

interface CreateGameState {
  isSubmitting: boolean;
  isValid: boolean;
}

export default class CreateGame extends React.Component<
  CreateGameProps,
  CreateGameState
> {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      isValid: false,
    };
  }

  validate = ({ playerName, gameTime, difficulty }) => {
    let isValid = true;

    if (!gameTime) {
      isValid = false;
    }

    if (!difficulty) {
      isValid = false;
    }

    if (!playerName || !playerName.trim()) {
      isValid = false;
    }

    this.setState({
      isValid,
    });
  };

  handleSubmit = async (submit) => {
    this.setState(
      {
        isSubmitting: true,
      },
      async () => {
        try {
          global.NewGame = {
            ...submit,
          };
          this.setState({
            isSubmitting: false,
          });
          const { navigate } = this.props.navigation;
          navigate("BuildLevels");
        } catch (error) {}
      }
    );
  };

  render() {
    return (
      <Theme>
        <Formik
          validate={this.validate}
          onSubmit={(data) => {
            this.handleSubmit(data);
          }}
          initialValues={{
            playerName: "",
            gameTime: 60,
            difficulty: 1,
          }}
          render={({ handleSubmit, values }) => (
            <CenteredContainer>
              <NameContainer>
                <FieldName>
                  <Text>Your Name</Text>
                </FieldName>
                <Field
                  component={TextInput}
                  disabled={this.state.isSubmitting}
                  name="playerName"
                  width={250}
                  inputStyle={{
                    width: 230,
                    textAlign: "center",
                  }}
                />
              </NameContainer>
              <OptionsContainer>
                <OptionContainer>
                  <OptionText>How long do you want to play?</OptionText>
                  <OptionInputContainer>
                    <Field
                      string
                      component={CounterInput}
                      disabled={this.state.isSubmitting}
                      name="gameTime"
                      minValue={1}
                      maxValue={1440}
                      initValue={60}
                    />
                  </OptionInputContainer>
                </OptionContainer>
                <OptionContainer>
                  <OptionText>How brave do you feel?</OptionText>
                  <OptionInputContainer>
                    <Field
                      string
                      component={CounterInput}
                      disabled={this.state.isSubmitting}
                      name="difficulty"
                      minValue={1}
                      maxValue={10}
                      initValue={5}
                    />
                  </OptionInputContainer>
                </OptionContainer>
              </OptionsContainer>

              <ButtonContainer>
                <View>
                  <Button
                    disabled={!this.state.isValid || this.state.isSubmitting}
                    title="Add drinks"
                    onPress={handleSubmit}
                  />
                </View>
              </ButtonContainer>
            </CenteredContainer>
          )}
        />
      </Theme>
    );
  }
}
